import React from "react";
import { makeStyles } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import { Box, Container } from "@material-ui/core";
import { HEADER_HEIGHT, DRAWER_WIDTH } from "../../../constants";
import InfoBanner from "layouts/InfoBanner";
import { useLocation } from "react-router-dom";
import { PORTAL_LAYOUT_ROUTE, RESUME_ROUTE } from "routes/portal/portalPaths";

export const useStyles = makeStyles((theme) => ({
  sidebarContainer: {
    [theme.breakpoints.down("sm")]: {
      width: "0px",
    },
  },
}));

const Layout = ({ header, sidebar, content, footer, bgColor }) => {
  const location = useLocation();
  const classes = useStyles();
  const theme = useTheme();

  const showInfoBanner =
    location.pathname === PORTAL_LAYOUT_ROUTE + RESUME_ROUTE;
  const infoBannerSpacing = showInfoBanner ? 48 : 0;
  const headerSpacing = header ? HEADER_HEIGHT : 0;
  const mainContainerTopSpacing = header ? theme.spacing(6) : theme.spacing(4);
  const boxContainerMinHeight =
    headerSpacing + mainContainerTopSpacing + infoBannerSpacing;

  return (
    <>
      {header}
      <Box display="flex" bgcolor={bgColor || "inherit"}>
        {sidebar && (
          <Box
            flexShrink={0}
            width={DRAWER_WIDTH}
            className={classes.sidebarContainer}
          >
            {sidebar}
          </Box>
        )}
        <Box flexGrow={1} maxWidth="100vw" marginTop={`${headerSpacing}px`}>
          {showInfoBanner && <InfoBanner />}
          <Box component="main" marginTop={`${mainContainerTopSpacing}px`}>
            <Container>
              <Box
                display="flex"
                flexDirection="column"
                minHeight={`calc(100vh - ${boxContainerMinHeight}px)`}
              >
                {content}
                {footer}
              </Box>
            </Container>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Layout;
